import React, { CSSProperties, Fragment } from "react";
import classNames from "classnames";
import { Container, Icon, IconName, Row } from "../components";
import { Text } from "./text";
import { Spacer } from "./spacer";
import { useI18n } from "../lib/i18n/i18n_provider";

interface PickerViewProps {
  title?: string;
  description?: string | null;
  placeholder?: string | null;
  icon?: IconName;
  disabled?: boolean;
  invalid?: boolean;
  override?: {
    root?: { style?: CSSProperties };
    arrow?: { style?: CSSProperties };
  };
}

/**
 * A button commonly used for call-to-actions.
 */
export function PickerView(props: PickerViewProps) {
  const { title, placeholder, description, icon, disabled, override } = props;
  const { locale } = useI18n();

  return (
    <div
      style={override?.root?.style}
      className={classNames("picker-view", disabled && "picker-view-disabled")}
    >
      <Row flex={1} alignItems="center">
        {icon && (
          <Fragment>
            <Spacer size={4} direction="horizontal" />
            <div className="picker-view-icon">
              <Container width={24}>
                <Icon name={icon} size={24} />
              </Container>
            </div>
            <Spacer size={8} direction="horizontal" />
          </Fragment>
        )}
        <div
          className={classNames(
            "picker-view-text",
            !title && "picker-view-placeholder"
          )}
        >
          <Text color={disabled ? "muted" : "default"}>
            {title || placeholder}
          </Text>
          {description && <Text size="sm">{description}</Text>}
        </div>
        <Spacer size={4} direction="horizontal" />
        <div
          style={{
            ...(locale.direction === "ltr" ? { right: 8 } : { left: 0 }),
            ...override?.arrow?.style,
          }}
          className="picker-view-arrow"
        >
          <Icon name="chevron-down" size={24} />
        </div>
      </Row>
    </div>
  );
}
